import axios from 'axios'
import { protocol } from '@/config'
export default {
  getUserInfo: (config = {}) => axios.get('userInfo', config),
  getToken: (config = {}) =>
    axios.get(`${protocol}//login.xueersi.com/auth/getAccessTokenNew`, {
      ...config,
      withCredentials: true
    })
}



// WEBPACK FOOTER //
// ./src/networks/api/Auth/index.js